export default "__VITE_ASSET__aH7fArLG__"